import { Typography } from '@mui/material'

export default function Caption({ children }: { children: string }) {
	return (
		<Typography variant="caption" color={theme => theme.palette.text.secondary}>
			{children}
		</Typography>
	)
}
